import { createReducer } from "@reduxjs/toolkit";

import { initialState, setOrgMembers } from "../Actions/orgMembersActions";

import type { OrgMembersState } from "../Actions/orgMembersActions";

export const orgMembersReducer = createReducer<OrgMembersState>(initialState, (builder) => {
    builder.addCase(setOrgMembers, (state, action) => {
        state.OrgMembers = action.payload;
    });
});